// extracted by mini-css-extract-plugin
export default {"title":"rc1H2","titleExtraSpacing":"L0rhs"};